import React from "react";
import {Select} from "antd";
import {
    OptionContainer,
    OptionIcon,
    OptionContent,
    OptionTitle,
    OptionDescription,
    LabelStyled,
    ResolutionSection,
    ResolutionHeader,
    ResolutionTitle,
    ResolutionDescription,
    ResolutionBadge
} from "./ResolutionSelector.styles";

export const ResolutionSelector = ({
    resolution,
    setResolution,
    resolutionOptions,
    currentResOption,
    isActionsEnabled = false
}) => {
    return (
        <ResolutionSection>
            <ResolutionHeader>
                <div>
                    <ResolutionTitle>Analiz Paneli</ResolutionTitle>
                    <ResolutionDescription>{currentResOption?.description}</ResolutionDescription>
                </div>
                <ResolutionBadge $resolution={resolution}>{currentResOption?.size}</ResolutionBadge>
            </ResolutionHeader>
            <div>
                <LabelStyled>
                    {isActionsEnabled ? "Hexagon Seviyesi" : "Seçim Seviyesi"}:
                </LabelStyled>
                <Select
                    value={resolution}
                    onChange={setResolution}
                    style={{width: "100%"}}
                    className="resolution-select"
                    optionLabelProp="label"
                    popupMatchSelectWidth={false}
                    dropdownStyle={{
                        zIndex: 9999999999999999999999999999,
                        position: "absolute",
                        top: "100%"
                    }}
                    aria-label="Hexagon analiz seviyesi seçimi"
                    aria-description="Harita üzerindeki hexagon analiz seviyesini seçin"
                    placeholder="Analiz seviyesi seçiniz"
                    options={resolutionOptions.map(option => ({
                        value: option.value,
                        label: option.label,
                        option
                    }))}
                    optionRender={({option}) => (
                        <OptionContainer>
                            <OptionIcon $value={option.value}>{option.option.value}</OptionIcon>
                            <OptionContent>
                                <OptionTitle>{option.option.label}</OptionTitle>
                                <OptionDescription>{option.option.description}</OptionDescription>
                            </OptionContent>
                        </OptionContainer>
                    )}
                />
            </div>
        </ResolutionSection>
    );
};
